
import { Col, Container, Row } from "reactstrap"; // Col & Row used below
import { GetInTouch } from "../../../constants";
import { ContactBoxData, TouchContent } from "../../../data/pages/Other";
import { routes } from "../../../routers/routes";
import Breadcrumbs from "../../commonComponents/breadcrumbs";
import CommonHeader from "../../home/common/CommonHeader";
import SellYourCarContactForm from "./common/SellYourCarContactForm";
import { dynamicImage, Image } from "../../../utils";

const ContactUs2Container = () => {
  return (
    <>
      <Breadcrumbs title="Sell Your Car" url={routes.Home.CarDemo1} mainClass="page-breadcrumbs-section page-breadcrumbs-section-sellurcar" />
      <section className="contact-section contact-2-section mb-5">
        <Container>
          {/* <Row className="gy-xl-0 gy-4 justify-content-center">
            {ContactBoxData.map((item, index) => (
              <Col xl={3} lg={4} sm={6} key={index}>
                <li className="contact-box">
                  <div className="contact-icon">{item.icon}</div>
                  <div className="contact-info">
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                  </div>
                </li>
              </Col>
            ))}
          </Row> */}
          <Row className="justify-content-center mb-5 section-t-md-space">
            <Col lg={8} md={10}>
              <Image
                src={dynamicImage("other/sellurcar.jpeg")}
                alt="Sell Your Car"
                className="img-fluid w-100 mb-4"
                style={{ borderRadius: "12px", objectFit: "cover" }}
              />
              <SellYourCarContactForm />
            </Col>
          </Row>

        </Container>
      </section>
    </>
  );
};

export default ContactUs2Container;
